import { AITissueModel } from 'components/AITools/models/AITissueModel';

export class AIAiosynModel extends AITissueModel {
  getModelOpacity() {
    return super.getOpacity().aiosyn;
  }
}
